
import React, { useState, useEffect, useRef, useCallback } from "react";
import cn from "classnames";
import styles from "../../components/battery/Battery.module.scss";
import ErrorsComponent from "components/battery/ErrorsComponent";
import EnergyComponent from "components/battery/EnergyComponent";
import SOCComponent from "components/battery/SOCComponent";
import SOHComponent from "components/battery/SOHComponent";
import AverageTemperature from "components/battery/AverageTempratureComponent";
import BatteriesErrorComponent from "components/battery/BatteriesErrorComponent";
import Master from "screen/Master";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";
import LocalStorageService from "services/tokenlocalstorage.service";
import TableAndSearch from "components/common/TableAndSearch";
import { getRequest } from "../../services/axiosBaseClient";
import { getRequestInAssets } from "services/axiosAssetsBaseClient";
import { getTime, getDate, getDay } from "components/common/dateTime";
import NewTableAndSearchMasterFilter from "components/common/NewTableAndSearchMasterFilter";

var offset = 0;
var pageLimit = 10;
var sitePaginationLimt = "";

function BatteryListView(props) {
  const [sohData, setSohData] = useState([]);
  const filterInitialValue = {
    startDate: parseInt(Date.now() / 1000) - 86400,
    endDate: parseInt(Date.now() / 1000),
    siteId: "",
    chargerId: "",
    state: "",
    city: "",
    cityId : null,
    stateId : null,
    zoneId: "",
    time: "HOUR_24",
  };

  const [open, setOpen] = React.useState(false);
  const [selectTime, setSelectTime] = useState("HOUR_24");
  const [filter, setFilter] = useState(filterInitialValue);
  const [energyGraph, setEnergyGraph] = useState([]);
  const [selectTimeValue, setSelectTimeValue] = useState("HOUR_24");
  const [data, setData] = useState("");
  const [sitesList, setSitesList] = useState([]);
  const [chargerList, setChargerList] = useState([]);
  const [userRole, setUserRole] = useState("");
  const [navigation, setNavigation] = useState(false);
  const [batteryList, setBatteryList] = useState([]);
  const [batteryCount, setBatteryCount] = useState(0);
  const [swappedEnergyData, setSwappedEnergyData] = useState([]);
  const [errorData, setErrorData] = useState([]);
  const [avgTempt, setAvgTempt] = useState([]);
  const [socData, setSocData] = useState([]);
  const [socErrorData, setSocErrorData] = useState([]);
  const [zoneId, setZoneId] = useState([]);
  const [batteryListCount, setBatteryListCount] = useState(0);
  const [loadingEnergy, setLoadingEnergy] = useState("true");
  const [loadingErrors, setLoadingErrors] = useState("true");
  const [loadingTemp, setLoadingTemp] = useState("true");
  const [loadingSOC, setLoadingSOC] = useState("true");
  const [loadingBatteries, setLoadingBatteries] = useState("true");
  const [loadingSOH, setLoadingSOH] = useState("true");

  const refOpen = useRef(open);
  function useOutsideAlerter(ref, ref1) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setOpen(false);
          refOpen.current = false;
        } else {
          if (
            refOpen.current &&
            ref1.current &&
            !ref1.current.contains(event.target)
          ) {
            refOpen.current = false;
            setOpen(false);
          } else {
            setOpen(true);
            refOpen.current = true;
          }
        }
      }

      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, ref1]);
  }

  const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
  if (headerFilterObj != null) {
    filter.state = headerFilterObj.state;
    filter.city = headerFilterObj.city;
    filter.zoneId = headerFilterObj.zoneId;
  }

  const wrapperRef = useRef(null);
  const wrapperRefInside = useRef(null);

  useOutsideAlerter(wrapperRef, wrapperRefInside);

  const handleClick = (btnType) => {
    if (open) {
      if (btnType === "reset") {
        setChargerList([]);
        setLoadingEnergy("true");
        setLoadingErrors("true");
        setLoadingTemp("true");
        setLoadingSOC("true");
        setLoadingBatteries("true");
        setLoadingSOH("true");
        filter.siteId = filterInitialValue.siteId;
        filter.chargerId = filterInitialValue.chargerId;
        filter.time = filterInitialValue.time;
        getSwappedEnergyData(
          filterInitialValue.startDate,
          filterInitialValue.endDate
        );
        getErrorData(filterInitialValue.startDate, filterInitialValue.endDate);
        getAvgTempt(filterInitialValue.startDate, filterInitialValue.endDate);
        getSocData(filterInitialValue.startDate, filterInitialValue.endDate);
        getSocErrorData(
          filterInitialValue.startDate,
          filterInitialValue.endDate
        );
        getSohData(filterInitialValue.startDate, filterInitialValue.endDate);
        setSelectTimeValue(filterInitialValue.time);
      } else {
        setLoadingEnergy("true");
        setLoadingErrors("true");
        setLoadingTemp("true");
        setLoadingSOC("true");
        setLoadingBatteries("true");
        setLoadingSOH("true");
        getSwappedEnergyData(filter.startDate, filter.endDate, filter);
        getErrorData(filter.startDate, filter.endDate, filter);
        getAvgTempt(filter.startDate, filter.endDate, filter);
        getSocData(filter.startDate, filter.endDate, filter);
        getSocErrorData(filter.startDate, filter.endDate, filter);
        getSohData(filter.startDate, filter.endDate, filter);
        setSelectTimeValue(selectTime);
      }
      setOpen(false);
    } else {
      setOpen(true);
    }
  };

  const pageLimitHandle = (string, limit) => {
    getBatteryList("timeFilterEnum=HOUR_24", string, limit);
    // sitePaginationLimt =limit;
  };

  const getBatteryList = useCallback(
    async (time, string, limit) => {
      if (string === "front") {
        offset = offset + 10;
      } else {
        if (offset > 0) {
          offset = offset - 10;
        }
      }
      await getRequest(
        `bss/getBatteryList?${time}&limit=${limit ? limit : pageLimit}&offset=${offset > 0 ? offset : 0
        }`
      ).then((res) => {
        if (res && res?.data) {
          res?.data?.batteriesInfo?.map((obj) => {
            obj.soh = obj.soh;
            obj.revenue = Math.round(obj.revenue * 100) / 100;
          });
          setBatteryList(res?.data.batteriesInfo);
          setBatteryListCount(res?.data.count);
        }
      });
    },
    [batteryList, batteryListCount]
  );

  useEffect(() => {
    window.scrollTo({ top: 0 });
    // getBatteryList("timeFilterEnum=HOUR_24");
  }, []);

  const getSites = useCallback(async (filter) => {
    let callString = "bss/site/siteList";
    if (filter?.cityId > 0) {
      callString += "?cityId=" + filter.cityId;
      if (filter.stateId > 0) {
        callString += "&stateId=" + filter.stateId;
      }
      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter?.stateId > 0) {
      callString += "?stateId=" + filter.stateId;

      if (filter.zoneId > 0) {
        callString += "&zoneId=" + filter.zoneId;
      }
    } else if (filter?.zoneId > 0) {
      callString += "?zoneId=" + filter.zoneId;
    }
    await getRequestInAssets(callString)
      .then((res) => {
        if (res.data != null) {
          setSitesList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    getBatteryList("timeFilterEnum=HOUR_24");
    pageLimitHandle();
  }, []);

  const getChargers = useCallback(async (siteId) => {
    await getRequestInAssets(
      `bss/swappingStation/getAllSwappingStationsBySite?siteId=${siteId}`
    )
      .then((res) => {
        if (res.data != null) {
          setChargerList(res?.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getTotalBattery = useCallback(async () => {
    var query =
      (headerFilterObj?.stateId === undefined || headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);

    await getRequest(`bss/batteryTotalCount?` + query)
      .then((res) => {
        if (res && res?.data) {
          setBatteryCount(res?.data?.totalCount);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  });

  const getSwappedEnergyData = useCallback(
    async (startDate, endDate, filter) => {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("headerFilter")
      );
      var query =
        (filter?.startDate
          ? "startDate=" + filter.startDate
          : startDate
            ? "startDate=" + startDate
            : "") +
        (filter?.endDate
          ? "&endDate=" + filter?.endDate
          : endDate
            ? "&endDate=" + endDate
            : "") +
        (filter?.siteId === undefined || filter?.siteId === ""
          ? ""
          : "&siteId=" + filter.siteId) +
        (filter?.chargerId === undefined || filter?.chargerId === ""
          ? ""
          : "&chargerId=" + filter.chargerId) +
        (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
          ? ""
          : "&timeFilterEnum=" + filter.timeFilterEnum) +
        (headerFilterObj?.stateId === undefined ||
          headerFilterObj?.stateId === ""
          ? ""
          : "&stateId=" + headerFilterObj.stateId) +
        (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
          ? ""
          : "&cityId=" + headerFilterObj.cityId) +
        (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
          ? ""
          : "&zoneId=" + headerFilterObj.zoneId);

      await getRequest(`bss/getBatteryEnergyDetails?` + query)
        .then((res) => {
          if (res && res?.data) {
            setSwappedEnergyData(res?.data);
            setLoadingEnergy("false");
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    },
    []
  );

  const getErrorData = useCallback(async (startDate, endDate, filter) => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    var query =
      (filter?.startDate
        ? "startDate=" + filter.startDate
        : startDate
          ? "startDate=" + startDate
          : "") +
      (filter?.endDate
        ? "&endDate=" + filter?.endDate
        : endDate
          ? "&endDate=" + endDate
          : "") +
      (filter?.siteId === undefined || filter?.siteId === ""
        ? ""
        : "&siteId=" + filter.siteId) +
      (filter?.chargerId === undefined || filter?.chargerId === ""
        ? ""
        : "&chargerId=" + filter.chargerId) +
      (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
        ? ""
        : "&timeFilterEnum=" + filter.timeFilterEnum) +
      (headerFilterObj?.stateId === undefined || headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);

    await getRequest(`bss/getBatteryErrorDetails?` + query)
      .then((res) => {
        if (res && res?.data) {
          setErrorData(res.data);
          setLoadingErrors("false");
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    if (headerFilterObj !== null) {
      filter.state = headerFilterObj.state;
      filter.city = headerFilterObj.city;
      filter.zoneId = headerFilterObj.zoneId;
    }
  });

  const getAvgTempt = useCallback(async (startDate, endDate, filter) => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    var query =
      (filter?.startDate
        ? "startDate=" + filter.startDate
        : startDate
          ? "startDate=" + startDate
          : "") +
      (filter?.endDate
        ? "&endDate=" + filter?.endDate
        : endDate
          ? "&endDate=" + endDate
          : "") +
      (filter?.siteId === undefined || filter?.siteId === ""
        ? ""
        : "&siteId=" + filter.siteId) +
      (filter?.chargerId === undefined || filter?.chargerId === ""
        ? ""
        : "&chargerId=" + filter.chargerId) +
      (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
        ? ""
        : "&timeFilterEnum=" + filter.timeFilterEnum) +
      (headerFilterObj?.stateId === undefined || headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);

    await getRequest(`bss/getBatteryTempDetails?` + query)
      .then((res) => {
        if (res && res?.data) {
          setAvgTempt(res?.data);
          setLoadingTemp("false");
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getSocData = useCallback(async (startDate, endDate, filter) => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    var query =
      (filter?.startDate
        ? "startDate=" + filter.startDate
        : startDate
          ? "startDate=" + startDate
          : "") +
      (filter?.endDate
        ? "&endDate=" + filter?.endDate
        : endDate
          ? "&endDate=" + endDate
          : "") +
      (filter?.siteId === undefined || filter?.siteId === ""
        ? ""
        : "&siteId=" + filter.siteId) +
      (filter?.chargerId === undefined || filter?.chargerId === ""
        ? ""
        : "&chargerId=" + filter.chargerId) +
      (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
        ? ""
        : "&timeFilterEnum=" + filter.timeFilterEnum) +
      (headerFilterObj?.stateId === undefined || headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);

    await getRequest("bss/getBatterySocDetails?" + query)
      .then((res) => {
        if (res && res?.data) {
          setSocData(res?.data);
          setLoadingSOC("false");
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getSocErrorData = useCallback(async (startDate, endDate, filter) => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    var query =
      (filter?.startDate
        ? "startDate=" + filter.startDate
        : startDate
          ? "startDate=" + startDate
          : "") +
      (filter?.endDate
        ? "&endDate=" + filter?.endDate
        : endDate
          ? "&endDate=" + endDate
          : "") +
      (filter?.siteId === undefined || filter?.siteId === ""
        ? ""
        : "&siteId=" + filter.siteId) +
      (filter?.chargerId === undefined || filter?.chargerId === ""
        ? ""
        : "&chargerId=" + filter.chargerId) +
      (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
        ? ""
        : "&timeFilterEnum=" + filter.timeFilterEnum) +
      (headerFilterObj?.stateId === undefined || headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);

    await getRequest(`bss/getBatterySocErrorDetails?` + query)
      .then((res) => {
        if (res && res?.data) {
          setSocErrorData(res?.data);
          setLoadingBatteries("false");
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  const getSohData = useCallback(async (startDate, endDate, filter) => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    var query =
      (filter?.startDate
        ? "startDate=" + filter.startDate
        : startDate
          ? "startDate=" + startDate
          : "") +
      (filter?.endDate
        ? "&endDate=" + filter?.endDate
        : endDate
          ? "&endDate=" + endDate
          : "") +
      (filter?.siteId === undefined || filter?.siteId === ""
        ? ""
        : "&siteId=" + filter.siteId) +
      (filter?.chargerId === undefined || filter?.chargerId === ""
        ? ""
        : "&chargerId=" + filter.chargerId) +
      (filter?.timeFilterEnum === undefined || filter?.timeFilterEnum === ""
        ? ""
        : "&timeFilterEnum=" + filter.timeFilterEnum) +
      (headerFilterObj?.stateId === undefined || headerFilterObj?.stateId === ""
        ? ""
        : "&stateId=" + headerFilterObj.stateId) +
      (headerFilterObj?.cityId === undefined || headerFilterObj?.cityId === ""
        ? ""
        : "&cityId=" + headerFilterObj.cityId) +
      (headerFilterObj?.zoneId === undefined || headerFilterObj?.zoneId === ""
        ? ""
        : "&zoneId=" + headerFilterObj.zoneId);

    await getRequest(`bss/getBatterySohDetails?` + query)
      .then((res) => {
        if (res && res?.data) {
          setSohData(res?.data);
          setLoadingSOH("false");
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  }, []);

  useEffect(() => {
    setLoadingEnergy("true");
    setLoadingErrors("true");
    setLoadingTemp("true");
    setLoadingSOC("true");
    setLoadingBatteries("true");
    setLoadingSOH("true");
    getSwappedEnergyData(filter.startDate, filter.endDate, filter);
    getErrorData(filter.startDate, filter.endDate, filter);
    getAvgTempt(filter.startDate, filter.endDate, filter);
    getSocData(filter.startDate, filter.endDate, filter);
    getSocErrorData(filter.startDate, filter.endDate, filter);
    getSohData(filter.startDate, filter.endDate, filter);
    getTotalBattery();
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    getSites(headerFilterObj);
  }, [props.headerFilter]);

  // useEffect(() => {
  //   getTotalBattery();
  // }, []);

  setTimeout(() => {
    if (navigation === false) {
      setNavigation(null);
    }
  }, 500);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });

    if (event.target.name === "time") {
      setSelectTime(event.target.value);

      if (value === "HOUR_12") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 43200,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_12");
      }
      if (value === "HOUR_24") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
      if (value === "WEEK") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 604800,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK");
      }
      if (value === "WEEK_2") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 1209600,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("WEEK_2");
      }
      if (value === "MONTH") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 2592000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH");
      }
      if (value === "MONTH_3") {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 7776000,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("MONTH_3");
      }
      if (value === null) {
        setFilter({
          ...filter,
          startDate: parseInt(Date.now() / 1000) - 86400,
          endDate: parseInt(Date.now() / 1000),
          [name]: value,
        });
        setSelectTime("HOUR_24");
      }
    }

    if (event.target.name === "siteId") {
      delete filter[name];
      setFilter({ ...filter, siteId: value, chargerId: "" });
      getChargers(event.target.value);
    }
    if (value == -1) {
      delete filter[name];
      setFilter(filter);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Battery Id",
        accessor: "batterySerial",
      },
      {
        Header: "SOC (%)",
        accessor: "soc",
      },
      {
        Header: "SOH(%)",
        accessor: "soh",
        Cell: (props) => {
          return (
            <>
              <span>{props.value?.includes("%") ? props.value : props.value + '%'}</span>
            </>
          );
        },
      },
      {
        Header: "Temp (°C)",
        accessor: "temperature",
      },
      {
        Header: "Current Status",
        accessor: "status",
      },
      {
        Header: "No of Swap",
        accessor: "swaps",
        Cell: (row) => {
          return (
            <div style={{ paddingLeft: "20px" }}>{row.row?.original?.swaps ? row.row?.original?.swaps : 0}</div>
          )
        },
      },
      {
        Header: "Revenue (₹)",
        accessor: "revenue",
        Cell: (props) => {
          return (
            <div style={{ paddingLeft: "20px" }}>{props.value}</div>
          );
        },
      },
      {
        Header: "Action",
        accessor: "batteryId",
        Cell: (props) => {
          return (
            <>
              <Link
                to={`/batteries/battery/${props.value}/${props.row.original.batterySerial}`}
              >
                <img
                  src={require("assets/view.png").default}
                  style={{ marginRight: 15, cursor: "pointer" }}
                />
              </Link>
            </>
          );
        },
      },
    ],
    []
  );

  // const getTime = (val) => {
  //   const endTime = Math.round(new Date().getTime() / 1000);
  //   const startTime = endTime - val * 3600;

  //   filter.endDate = endTime;
  //   filter.startDate = startTime;
  // };

  // useEffect(() => {
  //   getTime(filter.startDate);
  // }, []);

  const searchByBatteryID = (filter, searchString) => {
    if (searchString === undefined || searchString === "") {
      getBatteryList("timeFilterEnum=HOUR_24");
    } else {
      if (searchString != "" || searchString != undefined) {
        searchString = `?serialId=` + searchString;
      }
      getRequest(`bss/getBatteryList${searchString}`)
        .then((res) => {
          if (res && res?.data) {
            res?.data?.batteriesInfo?.map((obj) => {
              obj.soh = parseFloat(obj.soh).toFixed(2);
              obj.revenue = Math.round(obj.revenue * 100) / 100;
            });
            setBatteryList(res?.data?.batteriesInfo);
            setBatteryListCount(res?.data?.count);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    }
    // &limit=10&offset=0
  };
  const searchBatteryByFilter = async (filter, searchString) => {
    if (filter === undefined || filter === "") {
      getBatteryList("timeFilterEnum=HOUR_24");
    }
    setData(searchString);
    try {
      await getRequest(`bss/getBatteryList?${filter}
      `)
        .then((res) => {
          if (res && res?.data) {
            res?.data?.batteriesInfo?.map((obj) => {
              obj.soh = parseFloat(obj.soh).toFixed(2);
              obj.revenue = Math.round(obj.revenue * 100) / 100;
            });
            setBatteryList(res?.data.batteriesInfo);
            setBatteryListCount(res?.data.count);
          }
        })
        .catch((err) => {
          console.error("Error", err);
        });
    } catch (e) {
      console.log(e, "ERROR");
    }
  };

  useEffect(() => {
    const headerFilterObj = JSON.parse(LocalStorageService.get("headerFilter"));
    if (headerFilterObj !== null) {
      filter.state = headerFilterObj.state;
      filter.city = headerFilterObj.city;
      filter.zoneId = headerFilterObj.zoneId;
    }
    setUserRole(LocalStorageService.get("user-role"));
  }, []);

  return (
    <>
      <h2 id="Batteries_Heading" className={cn(styles.medium_title, styles.medium_title_layout)}>
        {"Batteries"}
      </h2>

      {/* <div
        className={cn(styles.card_list_block, styles.card_list_block_layout)}
      > */}
      <div id="Batteries_TotalCount_Container" className={cn(styles.block8, styles.block8_layout)}>
        <div id="Batteries_TotalCount_Container1" className={cn(styles.block8_item)}>
          <div id="Batteries_TotalCount_block" className={cn(styles.block23, styles.block23_layout)}>
            <div id="Batteries_TotalCount_box" className={cn(styles.box10, styles.box10_layout)}>
              <>
                <img
                id="Batteries_TotalCount_img"
                  src={require("assets/total_batteries_iconbg.png").default}
                // style={{marginRight: 15, cursor: 'pointer' }}
                />
              </>
              <div id="Batteries_TotalCount_box1" className={cn(styles.box11, styles.box11_layout)}>
                <>
                  <img
                  id="Batteries_TotalCount_img1"
                    src={require("assets/total_batteries_icon.png").default}
                    style={{
                      marginLeft: "7px",
                      marginTop: "6px",
                      cursor: "pointer",
                    }}
                  />
                </>
              </div>
            </div>
          </div>
        </div>
        <div className={cn(styles.block8_spacer)} />
        <div id="Batteries_TotalCount_TextBlock" className={cn(styles.block8_item1)}>
          <div id="Batteries_TotalCount_TextLayout" className={cn(styles.block21, styles.block21_layout)}>
            <div id="Batteries_TotalCount_Text" className={cn(styles.block22, styles.block22_layout)}>
              <h3
              id="Batteries_TotalCount_title"
                className={cn(styles.subtitle2, styles.subtitle2_layout)}
                style={{ width: "150px" }}
              >
                {"Total Batteries"}
              </h3>
            </div>

            <div className={cn(styles.block22, styles.block22_layout)}>
              <h3
              id="Batteries_TotalCount_value"
                className={cn(styles.subtitle2, styles.subtitle2_layout)}
                style={{ color: "black", marginTop: "5px" }}
              >
                {batteryCount}
              </h3>
            </div>
          </div>
        </div>
      </div>
      <hr
        className={cn(styles.line, styles.line_layout)}
        style={{ height: "3px" }}
      />

      <div
      id="Batteries_Graph_Filter_block"
        ref={wrapperRef}
        style={{ cursor: "pointer" }}
        className={cn(styles.block1, styles.block1_layout)}
      >
        <div id="Batteries_Graph_Filter_block1" className={cn(styles.block2, styles.block2_layout)}>
          <div id="Batteries_Graph_Filter_layout" className={cn(styles.block2_item)}>
            <div id="Batteries_Graph_Filter_layout1" className={cn(styles.block3, styles.block3_layout)}>
              <div
               id="Batteries_Graph_Filter_img"
                style={{
                  "--src": `url(${require("assets/filterblack.png").default})`,
                }}
                className={cn(styles.image1, styles.image1_layout)}
              />
            </div>
          </div>

          <div className={cn(styles.block2_spacer)} />

          <div id="Batteries_Graph_Filter_Title" className={cn(styles.text_body, styles.text_body_layout)}>
            {"Filters"}
          </div>
          {open && (
            <div id="filter" open={open} ref={wrapperRefInside}>
              <div
               id="Batteries_Graph_Filter_selectBlock"
                className={cn(
                  styles.status1_block,
                  styles.status1_block_layout
                )}
              >
                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="time"
                    id="time"
                    onChange={handleChange}
                    value={filter.time}
                  >
                    <option value="-1" disabled>
                      Select Time Period
                    </option>
                    <option value="HOUR_24" selected>
                      Last 24 hours
                    </option>
                    <option value="HOUR_12">Last 12 hours</option>
                    <option value="WEEK">Last 1 week</option>
                    <option value="WEEK_2">Last 2 weeks</option>
                    <option value="MONTH">Last 1 month</option>
                    <option value="MONTH_3">Last 3 months</option>
                  </select>
                </div>

                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="siteId"
                    id="siteId"
                    onChange={handleChange}
                    value={filter.siteId}
                  >
                    <option value="-1" selected>
                      Select Site
                    </option>
                    {sitesList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>

                <div>
                  <select
                    style={{ width: "80%", height: "35px" }}
                    name="chargerId"
                    id="chargerId"
                    onChange={handleChange}
                    value={filter.chargerId}
                  >
                    <option value="" disabled selected>
                      Select Swap Station
                    </option>
                    {chargerList.map((obj) => {
                      return <option value={obj.id}>{obj.name}</option>;
                    })}
                  </select>
                </div>

                <div>
                  <Button
                  id="Batteries_Graph_Filter_ResetButton"
                    style={{
                      background: "#E3324C",
                      color: "white",
                      margin: "15px 0px 6px 35px",
                      width: "85px",
                      height: "28px",
                    }}
                    onClick={() => {
                      handleClick("reset");
                    }}
                  >
                    Reset
                  </Button>
                  <Button
                  id="Batteries_Graph_Filter_ApplyButton"
                    style={{
                      background: "#23297A",
                      color: "white",
                      margin: "15px 0px 6px 20px",
                      width: "85px",
                      height: "28px",
                    }}
                    onClick={() => {
                      handleClick("apply");
                    }}
                  >
                    Apply
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <div id="Batteries_Graph_main_block1" className={cn(styles.flex4, styles.flex4_layout)}>
        <div id="Batteries_Energy" className={cn(styles.flex4_item)}>
          <div id="Batteries_Energy_block" className={cn(styles.block6, styles.block6_layout)}>
            <div id="Batteries_Energy_layout" className={cn(styles.block7, styles.block7_layout)}>
              <h5
              id="Batteries_Energy_title"
                className={cn(
                  styles.highlights_box,
                  styles.highlights_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>{"Energy"}</pre>
              </h5>
              {/* <div> */}
              <EnergyComponent
                loading={loadingEnergy}
                styles={{ with: "100%", height: "100%" }}
                data={swappedEnergyData}
                selectValue={selectTimeValue}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
        <div className={cn(styles.flex4_spacer)} />
        <div id="Batteries_Errors" className={cn(styles.flex4_item)}>
          <div id="Batteries_Errors_block" className={cn(styles.block6, styles.block6_layout)}>
            <div id="Batteries_Errors_layout" className={cn(styles.block7, styles.block7_layout)}>
              <h5
              id="Batteries_Errors_title"
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>{"Errors"}</pre>
              </h5>
              {/* <div> */}
              <ErrorsComponent
                loading={loadingErrors}
                styles={{ with: "100%", height: "100%" }}
                data={errorData}
                selectValue={selectTimeValue}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
        <div className={cn(styles.flex4_spacer)} />
        <div id="Batteries_AverageTemperature" className={cn(styles.flex4_item)}>
          <div id="Batteries_AverageTemperature_block" className={cn(styles.block6, styles.block6_layout)}>
            <div id="Batteries_AverageTemperature_layout" className={cn(styles.block7, styles.block7_layout)}>
              <h5
              id="Batteries_AverageTemperature_title"
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>
                  {"Average Temperature"}
                </pre>
              </h5>
              {/* <div> */}
              <AverageTemperature
                loading={loadingTemp}
                styles={{ with: "100%", height: "100%" }}
                data={avgTempt}
                selectValue={selectTimeValue}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>

      <div id="Batteries_Graph_main_block2" className={cn(styles.flex5, styles.flex5_layout)}>
        <div id="Batteries_SOC" className={cn(styles.flex5_item)}>
          <div id="Batteries_SOC_block" className={cn(styles.block6, styles.block6_layout)}>
            <div id="Batteries_SOC_layout" className={cn(styles.block7, styles.block7_layout)}>
              <h5
              id="Batteries_SOC_title"
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>{"SOC"}</pre>
              </h5>
              {/* <div> */}

              <SOCComponent
                loading={loadingSOC}
                styles={{ with: "100%", height: "100%" }}
                data={socData}
                selectValue={selectTimeValue}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
        <div className={cn(styles.flex5_spacer)} />
        <div id="Batteries_BatteriesError" className={cn(styles.flex5_item)}>
          <div id="Batteries_BatteriesError_block" className={cn(styles.block6, styles.block6_layout)}>
            <div id="Batteries_BatteriesError_layout" className={cn(styles.block7, styles.block7_layout)}>
              <h5
              id="Batteries_BatteriesError_title"
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>{"Batteries Error"}</pre>
              </h5>
              {/* <div> */}
              <BatteriesErrorComponent
                loading={loadingBatteries}
                styles={{ with: "100%", height: "100%" }}
                data={socErrorData}
                selectValue={selectTimeValue}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
        <div className={cn(styles.flex5_spacer)} />
        <div id="Batteries_SOH" className={cn(styles.flex5_item)}>
          <div id="Batteries_SOH_block" className={cn(styles.block6, styles.block6_layout)}>
            <div id="Batteries_SOH_layout" className={cn(styles.block7, styles.block7_layout)}>
              <h5
              id="Batteries_SOH_title"
                className={cn(
                  styles.highlights1_box,
                  styles.highlights1_box_layout
                )}
              >
                <pre className={cn(styles.highlights)}>{"SOH"}</pre>
              </h5>
              {/* <div> */}
              <SOHComponent
                loading={loadingSOH}
                styles={{ with: "100%", height: "100%" }}
                data={sohData}
                selectValue={selectTimeValue}
              />
              {/* </div> */}
            </div>
          </div>
        </div>
      </div>

      <hr className={cn(styles.line, styles.line_layout)} />

      <NewTableAndSearchMasterFilter
        pageLimitHandle={pageLimitHandle}
        searchOpts={{
          // onSearch: searchByBatteryID,
          placeholder: "Search by Battery Id",
          filter: true,
          onFilterSearch: searchBatteryByFilter,
          screentype: "battery",
        }}
        headerFilter={props.headerFilter}
        columns={columns}
        data={batteryList}
        onReset={getBatteryList}
        paginationDoubleScreen={true}
        swapStationCount={batteryListCount}
      />
    </>
  );
}
export default function BatteryList(props) {
  let Urls = window.location.href.toString().split(window.location.host)[1];
  const [headerFilter, setHeaderFilter] = useState(true);

  return (
    <>
      <Master
        batteryListName={Urls}
        opts={props}
        screen={BatteryListView}
        showStatus={true}
        headerFilter={headerFilter}
        setHeaderFilter={setHeaderFilter}
      />
    </>
  );
}
BatteryListView.inStorybook = true;
